import React from 'react';
import compose from 'recompose/compose';
import Card from '@material-ui/core/Card';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import { GET_ONE, translate } from 'react-admin';
import FormControl from '@material-ui/core/FormControl';
import dataProvider from '../../dataProvider';

const style = theme => ({
  formControl: {
    minWidth: 250,
    marginRight: '5em',
    marginLeft: '5em',
    display: 'flex',
    flexWrap: 'wrap',
  },
  root: {
    flex: 1,
  },
  cost: {
    marginRight: '1em',
    color: theme.palette.text.primary,
  },
});

class VersionInfo extends React.Component {
  state = {
    version: '',
  };

  componentDidMount() {
    dataProvider(GET_ONE, 'server-info', { id: 1 })
      .then(response => response.data.version)
      .then(version => {
        this.setState({ version: version });
      });
  }

  render() {
    const { translate, classes } = this.props;
    const buildVersion = process.env.REACT_APP_BUILD_VERSION;
    return (
      <Card>
        <List>
          <ListItem>
            <ListItemText primary={translate('about.title')} />
          </ListItem>
          <ListItem>
            <FormControl className={classes.formControl}>
              <ListItemText
                primary={translate('about.version')}
                secondary={this.state.version}
                className={classes.listItemText}
              />
            </FormControl>
          </ListItem>
          {buildVersion && buildVersion.length > 0 && (
            <ListItem>
              <FormControl className={classes.formControl}>
                <ListItemText
                  primary={translate('about.buildVersion')}
                  secondary={buildVersion}
                  className={classes.listItemText}
                />
              </FormControl>
            </ListItem>
          )}
        </List>
      </Card>
    );
  }
}

const enhance = compose(withStyles(style), translate);

export default enhance(VersionInfo);
